/** `yyyy-MM` to a month name, built as a local date: `new Date('2026-08')` is read as UTC. */
export const formatMonth = (period: string, language: string): string => {
  const [year, month] = period.split('-').map(Number);

  return new Date(year, month - 1, 1).toLocaleDateString(language, { month: 'long' });
};
